exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".l_btn {\r\n  color: #444;\r\n  background: #fafafa;\r\n  background-repeat: repeat-x;\r\n  border: 1px solid #bbb !important;\r\n  background: linear-gradient(to bottom, #ffffff 0, #eeeeee 100%);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff, endColorstr=#eeeeee, GradientType=0);\r\n  border-radius: 5px 5px 5px 5px;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  margin: 0;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  outline: none;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  line-height: normal;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/css-loader?{"sourceMap":false,"importLoaders":1}!D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/postcss-loader?{"ident":"postcss"}!D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/-config/base/btn_css.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/app/-config/base/btn_css.scss
// module chunks = 3